<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/5OZszT/images/cover.jpg?1692013314282" alt="This image is the cover for the book Loving Wisdom"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Loving Wisdom
      </h1>
      <p class="bookDescription body article font2">
        <p>A guide to Christian philosophy that engages with the biblical story</p><p>As human beings, we all qualify as philosophers, and Paul Copan contends that we take a position of trust (faith) shaped by philosophical stances but also personal heart commitments (worldviews). In this thoroughly revised and expanded second edition of <i>Loving Wisdom</i>, Copan explores philosophy of religion from a distinctively evangelical Christian perspective—biblically grounded, informed by apologetics, and engaging with questions about universal human longings. </p><p>Copan presents a distinctively and deliberately biblical philosophy of religion in <i>Loving Wisdom,</i>addressing a wide range of topics and questions as they arise in the metanarrative of scripture. He acknowledges the difficulties, mystery, and disagreements in “religion,” while attempting to show how the Christian faith does a much more adequate job of responding to a wide range of challenges as well as addressing our deepest human yearnings. With discussion questions for each chapter and an accessible approach, <i>Loving Wisdom</i> is ideal for the classroom or small groups.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Paul Copan
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      William B. Eerdmans Publishing Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?05efb7e6